import React from 'react';

/** Segmented scale with caller-computed positions; each marker has its own label lane. */
export default function RangeScale({
  segments = [],
  markers = [],
  boundaries = [],
  'aria-label': label,
}) {
  const visible = segments.filter((segment) => Number.isFinite(segment.value) && segment.value > 0);
  return (
    <div
      role="img"
      aria-label={label}
      className="min-w-0 font-instrument text-bun-label text-bun-stone"
    >
      {markers.map((marker) => {
        const position = Math.min(99, Math.max(1, marker.position));
        return (
          <div key={marker.id} className="relative h-6">
            <span
              className="absolute max-w-full whitespace-nowrap font-strong text-bun-text"
              style={position < 50 ? { left: `${position}%` } : { right: `${100 - position}%` }}
            >
              {marker.label}
            </span>
          </div>
        );
      })}
      <div className="relative">
        <div className="flex h-12 overflow-hidden rounded-bun bg-bun-mist-deep">
          {visible.map((segment) => (
            <div
              key={segment.id}
              className="flex min-w-0 basis-0 items-center justify-center border-r border-bun-surface last:border-r-0"
              style={{ flexGrow: segment.value, backgroundColor: segment.color }}
            >
              {segment.label && (
                <span className="rounded-bun-sm bg-bun-surface px-1 text-bun-meta font-semibold text-bun-text">
                  {segment.label}
                </span>
              )}
            </div>
          ))}
        </div>
        {markers.map((marker) => (
          <div
            key={marker.id}
            aria-hidden="true"
            className="absolute inset-y-0 w-px bg-bun-ink"
            style={{ left: `${Math.min(100, Math.max(0, marker.position))}%` }}
          />
        ))}
        {boundaries.map((boundary) => (
          <div
            key={boundary.id}
            className="absolute top-full mt-1 whitespace-nowrap"
            style={{
              left: `${Math.min(100, Math.max(0, boundary.position))}%`,
              transform: 'translateX(-50%)',
            }}
          >
            {boundary.label}
          </div>
        ))}
      </div>
      {boundaries.length > 0 && <div aria-hidden="true" className="h-6" />}
    </div>
  );
}
